// StoryMore.jsx
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withTranslation } from 'react-i18next';
import { color } from '../style/variables.js';

import FeedComponent from '../container/FeedComponent.js';

import { TranslationNamespace } from '../resource/translationNamespace.js';

import { CategoryLayout } from '../resource/feedConstants.js';

import { headerHeight } from '../style/variables.js';
import ResetButtonStyle from '../style/ResetButtonStyle.js';

import BackIcon from '../../img/ic_topbar_back.svg';

class StoryMore extends Component {
  nextTick = null;
  componentWillUnmount() {
    clearTimeout(this.nextTick);
    if (!window.__IS_HYDRATED__) {
      window.__IS_HYDRATED__ = 'StoryMore';
    }
  }

  render() {
    const { category, titleI18nId, goBack, t } = this.props;

    return (
      <StyledStoryMore>
        <Header>
          <HeaderLeft>
            <GoBack onClick={goBack}>
              <img src={BackIcon} title="back" />
            </GoBack>
          </HeaderLeft>
          <HeaderTitle>
            {t(titleI18nId, { ns: TranslationNamespace.FEED })}
          </HeaderTitle>
        </Header>
        <Main>
          <InfiniteScrollerContainer>
            <FeedComponent
              category={category}
              layout={CategoryLayout.GRID}
              shouldShowTitle={false}
              shouldShowMoreLink={false}
            />
          </InfiniteScrollerContainer>
        </Main>
      </StyledStoryMore>
    );
  }
}

StoryMore.propTypes = {
  category: PropTypes.string,
  titleI18nId: PropTypes.string.isRequired,
  goBack: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

StoryMore.defaultProps = {
  category: '',
  descriptionI18nId: '',
};

const StyledStoryMore = styled.div`
  position: relative;
  padding-top: var(--space-to-pinned-notification);
`;
const Header = styled.header`
  position: fixed;
  z-index: 2;
  border-bottom: 1px solid ${color.neutral['30_alpha_50']};
  display: flex;
  align-items: center;
  padding-left: 60px;
  width: 100%;
  height: ${headerHeight}px;
  top: var(--space-to-pinned-notification);
  background-color: ${color.grey['900']};
  font-size: 16px;
  font-weight: 600;
`;

const HeaderTitle = styled.h1`
  margin: 0px;
  margin-left: 4px;
  font-size: 18px;
  font-weight: 600;
`;

const HeaderLeft = styled.div`
  position: absolute;
  top: 50%;
  left: 16px;
  display: flex;
  align-items: center;
  transform: translateY(-50%);
`;

const GoBack = styled.button`
  ${ResetButtonStyle};
  flex: none;
  height: 32px;
  :hover {
    opacity: 0.7;
  }
  & > img {
    height: 100%;
    vertical-align: top;
  }
`;

const InfiniteScrollerContainer = styled.div`
  padding-top: ${headerHeight + 1}px;
`;

const Main = styled.main`
  max-width: 960px;
  margin: 0 auto;
`;

export default withTranslation()(StoryMore);
